import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 14H20M4 18H20M4 10H20M4 6H13" vectorEffect="non-scaling-stroke" />
	</SVG>
);
